const record = (value: unknown): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value);

/** Resolve a single owning track through native groups; never choose an arbitrary parent. */
export function companyVoiceOwner(document: unknown, clipId: string): {
  track: Record<string, unknown>; trackId: string; parents: Record<string, unknown>[]; parentIds: string[];
} {
  const invalid = () => new Error('음성의 그룹 연결을 확인해 주세요. 중복 연결을 정리하거나 병합을 해제한 뒤 다시 선택할 수 있습니다.');
  if (!record(document) || !record(document.items) || !Array.isArray(document.tracks)) throw invalid();
  const items = document.items, entries = Object.entries(items);
  if (entries.length > 10000 || document.tracks.length > 1000) throw invalid();
  const parents: Record<string, unknown>[] = [], parentIds: string[] = [], seen = new Set<string>();
  let id = clipId;
  for (let depth = 0; depth <= 64; depth++) {
    if (seen.has(id) || !record(items[id])) throw invalid();
    seen.add(id);
    const tracks = document.tracks.flatMap(track => record(track) && Array.isArray(track.items)
      ? track.items.filter(key => key === id).map(() => track) : []);
    const groups = entries.flatMap(([key, item]) => record(item) && item.type === 'group' && Array.isArray(item.children)
      ? item.children.filter(child => child === id).map(() => ({key, item})) : []);
    if (tracks.length + groups.length !== 1) throw invalid();
    if (tracks.length) {
      const track = tracks[0];
      if (!track || typeof track.id !== 'string') throw invalid();
      return {track, trackId: track.id, parents, parentIds};
    }
    const parent = groups[0];
    if (!parent || parent.item.id !== parent.key || !Array.isArray(parent.item.children)
      || new Set(parent.item.children).size !== parent.item.children.length
      || parent.item.children.some(child => typeof child !== 'string' || !record(items[child]))) throw invalid();
    parents.push(parent.item); parentIds.push(parent.key); id = parent.key;
  }
  throw invalid();
}
